












import { Component, Prop, Vue } from "vue-property-decorator";
import SimpleListLi from "@/basics/list/SimpleListLi.vue";

export interface BuildingData {
  token: string;
  name: string;
}

@Component({ components: { SimpleListLi } })
export default class SearchBuildingResult extends Vue {
  @Prop({ type: Array, required: true }) buildings!: BuildingData[];
}
